import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"

import ActionButton from "../common/button/actionbutton.component.jsx"
import Icon from "../common/icon/icon.component.jsx"
import IntlProps from "../state/helpers/IntlProps.js"

type Props = {
    onStepCompleted: (payload: unknown) => void
}

const QMPaymentOnboardingSetup = (props: Props & IntlProps) => {

    const submit = (event: React.MouseEvent, skip: boolean) => {
        event.preventDefault()
        props.onStepCompleted({ "skip": skip })
    }


    return (
        <div className="row py-0 justify-content-center pb-5">
            <div className={"col-12 mb-3"}>
                <div className="row py-0 justify-content-center">
                    <div className="col-lg-6 col-md-8 col-12">
                        <h1 className="text-center custom-lead text-custom-primary mb-0">
                            <FormattedMessage
                                id="welcome.step_2.payment_setup"
                                defaultMessage="Payment setup"
                            />
                        </h1>
                    </div>
                </div>
            </div>
            <div className={"col-12"}>
                <div className={"row justify-content-center"}>
                    <div className={"col-lg-5 col-md-8 col-12"}>
                        <div className={"row justify-content-center"}>
                            <div className="col-12 ui-module text-center pt-0" style={{ paddingLeft: "0.9rem", paddingRight: "0.9rem" }}>
                                <div className="row pb-2 pt-3 mb-3 bg-light border rounded-top">
                                    <div className="col-12 text-center">
                                        <h5 className="col-12 align-items-center justify-content-center d-flex"
                                            style={{ borderBottom: "none", marginBottom: "0", paddingBottom: "0" }}>
                                            <Icon value={"award"} className={"mr-3"} size={"30"} />
                                            <FormattedMessage
                                                id="welcome.step_2.recommended"
                                                defaultMessage="Recommended"
                                            />
                                        </h5>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <div className={"px-2 mt-4"}>
                                        <ActionButton className={"btn btn-md btn-primary"} onClick={
                                            (event: React.MouseEvent) => {
                                                submit(event, false)
                                            }
                                        }>
                                            <Icon value={"credit-card"} className={"mr-2"} />
                                            <FormattedMessage
                                                id="welcome.payment_setup.enable_test_mode.btn_label"
                                                defaultMessage="Enable Payment Test Mode"
                                            />
                                        </ActionButton>
                                    </div>
                                    <div className={"px-2 mt-4"}>
                                        <p>
                                            <b>
                                                <FormattedMessage
                                                    id="welcome.payment_setup.enable_test_mode.message1"
                                                    defaultMessage="This payment test mode is meant for testing."
                                                />
                                            </b>
                                        </p>
                                        <p>
                                            <FormattedMessage
                                                id="welcome.payment_setup.enable_test_mode.message2"
                                                defaultMessage="{underlinedText} when you pay quotes, orders, invoices or any other documents."
                                                values={{
                                                    underlinedText: <u>
                                                        <FormattedMessage
                                                            id="welcome.payment_setup.enable_test_mode.message3"
                                                            // eslint-disable-next-line max-len
                                                            defaultMessage="No credit card or bank account will be charged"
                                                        />
                                                    </u>
                                                }}
                                            />
                                        </p>
                                        <p>
                                            <FormattedMessage
                                                id="welcome.payment_setup.enable_test_mode.message4"
                                                defaultMessage="Once you're ready, you can activate {link}."
                                                values={{
                                                    link: <a
                                                        href="https://www.quotemachine.com/en/payments/"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <FormattedMessage
                                                            id="welcome.payment_setup.enable_test_mode.message5"
                                                            // eslint-disable-next-line max-len
                                                            defaultMessage="our payment solution"
                                                        />
                                                    </a>
                                                }}
                                            />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 text-center px-0">
                                <div className="text-right">
                                    <ActionButton className={"btn btn-sm btn-link px-0"} onClick={
                                        (event: React.MouseEvent) => {
                                            submit(event, true)
                                        }
                                    }>
                                        <Icon value={"caret-right"} />
                                        <FormattedMessage
                                            id="welcome.skip_payment_setup"
                                            defaultMessage="Skip to the next step"
                                        />
                                    </ActionButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default injectIntl(QMPaymentOnboardingSetup)


// WEBPACK FOOTER //
// ./src/onboarding/QMPaymentOnboardingSetup.tsx